export default {
	methods: {
		isMobile () {
			return window.innerWidth <= 768
		}
	}
}
